module.exports = __webpack_public_path__ + "ico-gf.3ba03c8b14f9f8f5d2ca.svg";


//////////////////
// WEBPACK FOOTER
// /Users/nikolay/Documents/GitHub/menu-web/src/assets/img/ico-gf.svg
// module id = ../../../../../src/assets/img/ico-gf.svg
// module chunks = styles